import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=56249416&scoped=true&"
import script from "./Brief.vue?vue&type=script&lang=js&"
export * from "./Brief.vue?vue&type=script&lang=js&"
import style0 from "./Brief.vue?vue&type=style&index=0&id=56249416&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56249416",
  null
  
)

export default component.exports